import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../chunks/tslib.es6.js";
import e from "../../core/Accessor.js";
import o from "../../core/Handles.js";
import { when as s } from "../../core/watchUtils.js";
import { property as i } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as r } from "../../core/accessorSupport/decorators/subclass.js";

var a = /*#__PURE__*/function (_e) {
  _inherits(a, _e);

  var _super = _createSuper(a);

  function a(t) {
    var _this;

    _classCallCheck(this, a);

    _this = _super.call(this, t), _this._handles = new o(), _this.navigationMode = "pan", _this.view = null;
    return _this;
  }

  _createClass(a, [{
    key: "initialize",
    value: function initialize() {
      this._handles.add(s(this, "view.inputManager", this._setNavigationMode.bind(this)));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._handles.destroy(), this._handles = null, this.view = null;
    }
  }, {
    key: "state",
    get: function get() {
      return this.get("view.ready") && "3d" === this.view.type ? "ready" : "disabled";
    }
  }, {
    key: "toggle",
    value: function toggle() {
      "disabled" !== this.state && (this.navigationMode = "pan" !== this.navigationMode ? "pan" : "rotate", this._setNavigationMode());
    }
  }, {
    key: "_setNavigationMode",
    value: function _setNavigationMode() {
      this.get("view.inputManager").primaryDragAction = "pan" === this.navigationMode ? "pan" : "rotate";
    }
  }]);

  return a;
}(e);

t([i({
  readOnly: !0
})], a.prototype, "state", null), t([i()], a.prototype, "navigationMode", void 0), t([i()], a.prototype, "view", void 0), a = t([r("esri.widgets.NavigationToggleViewModel")], a);
var n = a;
export { n as default };